<app-user-header class="d-md-none"></app-user-header> 
<div class="row m-0 h-100 row-container"> 



  <div class="col-formed-side pe-0 ps-0 section-side-nav h-100 d-none d-md-block">
    <app-sidebar></app-sidebar>
  </div>
  <div class="col-formed-main big-area wrap-container">
    <div class="col-12 big-area ">
        <div class="wrapperi pb-4 pt-4">

            <div class="col-12">
        
                <div class="pointer" (click)="goBack()">
                    <p class="semiboldtextblue16 mb-0"><i class="fal normaltextblue16 fa-chevron-left icon-blue me-2"></i>Takaisin</p>
                </div>
            </div>

            <div class="col-12 row" *ngIf="successMessage">
                <div class="col-1"></div>
                <div class="col-10 alert alert-success">
                    <p class="text-center">Tarjouksen jättäminen onnistui.</p>
                </div>
                <div class="col-1"></div>
            </div>
            <div class="col-12 row" *ngIf="errorMessage">
                <div class="col-1"></div>
                <div class="col-10 alert alert-danger">
                    <p class="text-center">Tarjouksen jättäminen epäonnistui.</p>
                </div>
                <div class="col-1"></div>
            </div>
        
          
          
            <div class="col-12 p-0 m-0" *ngIf="opening">
        
              <div class="col-12 col-md-12  mt-4">
                <div class="row m-0 col-12 m-0">
                    <div [ngClass]="type == 'own' ? 'col-6' : 'col-8'" class=" ps-0">
                        <div class=" bg-w p-4">
                            <div class="col-12 d-flex justify-content-between p-0">
                                <div class="company-tag d-flex">
                                    <img src="{{opening.logo}}" width="30" height="30" alt="">
                                    <p class="semiboldtextblue14 margin-tag mb-0">{{opening.businessName}}</p>
                                </div>
                                <div class="d-flex align-items-center">
                                    <p class="normaltextblue14 mb-0">Haku päättyy: {{opening.expiryDate | formateDate}}</p>
                                </div>
                            </div>
                            <div class="col-12 p-0 d-flex justify-content-between">
                                <div class="">
                                    <p class="boldtextblue24 title-margin">{{opening.title}}</p>
                                </div>
                                <div class="d-flex justify-content-center">
                                    <i class="far fa-eye pe-2 blue-icon title-margin-plus"></i>
                                    <p class="mb-0 formed-sub-title title-margin">{{opening.views_number}}</p>
            
                                </div>
            
                            </div>
                            <div class="col-12 p-0">
                                <p class="normaltextblue14 allow-line-breaks">{{opening.description_fi}}</p>
                            </div>
                            <hr class="hr-formed mt-4">
                            <div class="col-12 title-margin row">
                                <div class="col-6">
                                    <div class="d-flex mt-2">
                                        <p class="semiboldtextblue16 mb-0">Ammattilainen:</p>
                                        <p class="normaltextblue16 mb-0 ms-2">{{opening.mdType.name_fi}}</p>
                                    </div>
                                    <div class="d-flex mt-2" *ngIf="opening.mdSubType">
                                        <p class="semiboldtextblue16 mb-0">Erikoisala:</p>
                                        <p class="normaltextblue16 mb-0 ms-2">{{opening.mdSubType.name_fi}}</p>
                                    </div>
                                    <div class="d-flex mt-2"*ngIf="opening['area']">
                                        <p class="semiboldtextblue16 mb-0" >Maakunta:</p>
                                        <p class="normaltextblue16 mb-0 ms-2">{{opening['area']}}</p>
                                    </div>
                                    
                                </div>
                                <div class="col-6">

                                </div>
                            </div>
                            <hr class="hr-formed mt-4">
                            <div class="col-12">
                                <p class="normaltextblue16 text-wrap">{{opening.description}}</p>
                            </div>
                            <div class="col-12 title-margin d-inline-flex">
                                <div *ngIf="!opening.already_applied && type != 'own'" class="">
                                    <button class="btn btn-formed-main-blue mb-4" (click)="leaveOffer()">Lähetä tarjous</button>
                                </div>
                                <ng-container *ngIf="type == 'own'">
                                    <button class="btn btn-formed-main-blue me-4" routerLink="/{{businessID}}/marketplaces/edit-marketplace/{{marketplaceID}}">Muokkaa tietoja</button>
                                    <button class="btn btn-formed-delete" data-bs-toggle="modal" data-bs-target="#delete-confirm-modal">Poista ilmoitus</button>
                                </ng-container>
                                <div *ngIf="opening.already_applied" class="col-12">
                                    <div class="col-12">
                                        <hr class="hr-formed">
                                        <p class="semiboldtextblue16">Organisaatiosi on jo jättänyt tarjouksen ilmoitukseen</p>
                                    </div>
                                </div>
            
                            </div>
                        </div>
            
                    </div>
                    <div [ngClass]="type == 'own' ? 'col-6' : 'col-4'" class=" pe-0">
                        <div class="bg-w">
                            <div class="p-4">
                                <div class="" *ngIf="type == 'own'; else other_content">
                                    <p class="formed-sub-title">Saamasi tarjoukset</p>
                                    <div class="row" *ngIf="opening && opening.offers && opening.offers.length > 0 && type == 'own'">
                                        <div class="col-md-6" *ngFor="let offer of opening.offers">
                                            <div [ngClass]="offer.is_new ? 'offer-card-new' : 'offer-card'" class=" h-100 p-3">
                                                <div class="card-body h-100">
                                                    <div class="col-12 p-0 row m-0">
                                                        <div class="d-flex justify-content-between p-0 w-100">
                                                            <div class="d-flex">
                                                                <div *ngIf="offer.company.logo;else no_image">
                                                                    <img width="25" height="25" src="{{offer.company.logo}}"  alt="">
                                                                </div>
                                                                <ng-template #no_image>
                                                                    <img src="../../assets/images/formed_blur.jpg" width="25" height="25" alt="">  
                                                                </ng-template>
                                                                <p class="mb-1 semiboldtextblue14 mt-1 ms-2"> {{offer.company.businessName}}</p>


                                                            </div>
                                                            <div class="" *ngIf="offer.is_new">
                                                                <p class="gradient-green-text-14 mt-1">Uusi</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 p-0 mt-2">
                                                        <div class="bg-f-b p-3">
                                                            <p class="normaltextblue16 mb-0 text-center"><span *ngIf="offer.hourlyWage">{{offer.hourlyWage}}€/h</span></p>
                                                        </div>
                                                    </div>
                                                    <div class="">
                                                        <div class="mt-3 text-center d-flex justify-content-center mt-4" >
                                                            <button type="button" (click)="readOffer(offer)" class="btn btn-formed-main-green w-100">Lue tarjous</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                        
                                        </div>
                                        </div>
                                </div>
                                <ng-template #other_content>
                                    <p class="formed-sub-title">Sinua voisi kiinnostaa...</p>
                                </ng-template>
                            </div>
                        </div>
                    </div>

                    </div>
        
                </div>

          </div>
        </div>
    </div>

</div>
    </div>

                


        <!-- Modal Check before deleting offer -->
        <button data-bs-toggle="modal" id="open-offer" data-bs-target="#open-offer-modal" style="display:none"></button>
        <div class="modal fade" id="open-offer-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog " role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Jätä tarjouksesi</h5>
                <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <i class="fal fa-times"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="d-flex justify-content-center pt-4 pb-4">
                    <div class=" d-flex">
                        <img src="{{opening.logo}}" width="30" height="30" alt="">
                        <p class="semiboldtextblue14 margin-tag mb-0">{{opening.businessName}}</p>
                    </div>
                </div>

                    
                    <p class="normaltextblue16 mb-2 mt-2">Kirjoita tuntipalkka (€/h)</p>
                    <div class="col-12 row m-0 pt-2">
                        <div class="col-12 ps-0">
                            <div class="form-floating mb-2 col-md-12 col-12 p-0">
                                <input type="number"  placeholder="tuntipalkka"  id="hourlyWage" class="form-control" />
                                <label for="hourlyWage">tuntipalkka</label>
                
                            </div>
                        </div>
                    </div>

                    <div class="col-12 row m-0 pt-2 ps-0">

                        <p class="normaltextblue16 ps-0 mb-2 mt-2">Kuvaus</p>

  
                        <div class="form-floating mb-2 col-12 p-0">
                            <textarea type="text" style="height:300px" placeholder="Kuvaus"  id="description" class="form-control" ></textarea>
                            <label for="addInfo">Kuvaus</label>
            
                        </div>
                    </div>
                    <div class="d-flex justify-content-between">
                        <div class="">
                            <button data-bs-dismiss="modal" aria-label="Close" (click)="clearFields()" id="close-offer-modal" class="btn btn-formed-main-red w-100 mt-4">Peruuta</button>

                        </div>
                        <div class="">
                            <button (click)="sendOffer()" class="btn btn-formed-main-green w-100 mt-4">Lähetä</button>

                        </div>
                    </div>

                </div>
            </div>
            </div>
        </div>


                <!-- Modal Check before deleting offer -->
                <button data-bs-toggle="modal" id="open-read-offer" data-bs-target="#open-read-offer-modal" style="display:none"></button>
                <div class="modal fade" id="open-read-offer-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Saamasi tarjous</h5>
                        <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body" *ngIf="currentOffer">

                        <div class="offer-card p-4">
                            <div class="d-flex mb-2">
                                <img src="{{currentOffer.company.logo}}" width="25" height="25" alt="">
                                <p class="semiboldtextblue14 mt-1 ms-3">{{currentOffer.company.businessName}}</p>
                            </div>
                            <div class="bg-f-b pt-2 pb-2">
                                <p class="text-center mb-0 semiboldtextblue14">{{currentOffer.hourlyWage}}€/h</p>
                            </div>
                        </div>

                        <div class="mt-4">
                            <p class="text-start normaltextblue16">Kuvaus</p>
                        </div>
                        <div class="mt-4">
                            <div class="bg-f-b p-3">
                                <p class="allow-line-breaks normaltextblue60014">{{currentOffer.description}}</p>

                            </div>
                        </div>

            
                        </div>
                    </div>
                    </div>
                </div>

            <!-- Modal Check before deleting offer -->
            <button data-bs-toggle="modal" id="open-read-offer" data-bs-target="#open-read-offer-modal" style="display:none"></button>
            <div class="modal fade" id="open-read-offer-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Saamasi tarjous</h5>
                    <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

                    </button>
                </div>
                <div class="modal-body" *ngIf="currentOffer">
    
                        <h5 class="text-start">Kuvaus</h5>
                        <p class="allow-line-breaks">{{currentOffer.description}}</p>


        
                    </div>
                </div>
                </div>
            </div>

        <!-- Modal Check before deleting offer -->
        <button data-bs-toggle="modal" id="delete-confirm" data-bs-target="#delete-confirm-modal" style="display:none"></button>
        <div class="modal fade" id="delete-confirm-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="text-center w-100" id="exampleModalLabel">Vahvistus</h5>
                <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
                <button id="close-confirm-modal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

                </button>
            </div>
            <div class="modal-body">
                <p class="text-center">Kerro meille syy miksi haluat poistaa ilmoituksesi.</p>

                <div class="form-floating mb-2 col-12  p-0">
                    <select type="text" id="deletion-reason" placeholder="Valitse poiston syy" class="form-control" >
                        <option value=""></option>
                        <option value="formed_found">Tekijä löytyi Formedin kautta</option>
                        <option value="other_place_found">Tekijä löytyi muualta </option>
                        <option value="cannot_find">Tekijää ei löydy</option>
                        <option value="error_in_opening">Ilmoituksessa on virhe</option>
                        <option value="other">Muu</option>
                        </select>
                    <label for="md-type">Valitse poiston syy*</label>
                </div>

                <div class="text-center justify-content-center d-flex col-12 mt-4 ">
                    <button class="btn btn-formed-delete" (click)="deleteMarketplace()">Poista ilmoitus</button>
                </div>

            </div>
            </div>
        </div>
        </div>